export enum AppSumoErrorEnum {
  INVALID_TOKEN = 'INVALID_TOKEN',
  ALREADY_LOGGED_IN = 'ALREADY_LOGGED_IN',
}
